// extracted by mini-css-extract-plugin
export default {"customTooltip":"Rechart_customTooltip__o3nPp"};